<template>
  <div>

<!--    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">首页2</div>-->

    <div style="background-color: #eee;overflow-y: auto;" :style="th">

      <div style="padding: 10px;"></div>

    </div>


  </div>

</template>



<script>


import {timeStr} from "@/common/times";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Home",

  components:{

  },
  data: function () {
    return {

      th:'',


      chartSettings_total_day:{
        labelMap:{
          day:"日期",
          count:"订单数",
          money:"销售额",
        }
      },
      chartData_total_day: {
        columns: ['day', 'count','money'],
        rows: [
          {'day':'1','count':'20','money':'200'},
          {'day':'2','count':'25','money':'250'},
          {'day':'3','count':'15','money':'150'},
          {'day':'4','count':'35','money':'350'},
          {'day':'5','count':'36','money':'360'},
          {'day':'6','count':'38','money':'380'},
          {'day':'7','count':'42','money':'420'},
          {'day':'8','count':'15','money':'150'},
          {'day':'9','count':'17','money':'170'},
          {'day':'10','count':'49','money':'500'},
          {'day':'11','count':'5','money':'50'},
          {'day':'12','count':'15','money':'150'},
          {'day':'13','count':'15','money':'150'},
          {'day':'14','count':'15','money':'150'},
          {'day':'15','count':'15','money':'150'},
          {'day':'16','count':'15','money':'150'},
          {'day':'17','count':'15','money':'150'},
          {'day':'18','count':'15','money':'150'},
          {'day':'19','count':'15','money':'150'},
          {'day':'20','count':'15','money':'150'},
          {'day':'21','count':'15','money':'150'},
          {'day':'22','count':'22','money':'220'},
          {'day':'23','count':'15','money':'150'},
          {'day':'24','count':'15','money':'150'},
          {'day':'25','count':'15','money':'150'},
          {'day':'25','count':'15','money':'150'},
          {'day':'27','count':'15','money':'150'},
          {'day':'28','count':'15','money':'150'},
          {'day':'29','count':'15','money':'150'},
          {'day':'30','count':'15','money':'150'},

        ]
      },

      chartSettings_total_month:{
        labelMap:{
          month:"月份",
          count:"订单数",
          money:"销售额",
        }
      },
      chartData_total_month: {
        columns: ['month', 'count','money'],
        rows: [
          {'month':'1','count':'203','money':'2000'},
          {'month':'2','count':'153','money':'1350'},
          {'month':'3','count':'171','money':'1550'},
          {'month':'4','count':'153','money':'1350'},
          {'month':'5','count':'153','money':'1350'},
          {'month':'6','count':'223','money':'2350'},
          {'month':'7','count':'153','money':'1350'},
          {'month':'8','count':'353','money':'3350'},
          {'month':'9','count':'153','money':'1150'},
          {'month':'10','count':'153','money':'1350'},
          {'month':'11','count':'123','money':'1250'},
          {'month':'12','count':'153','money':'1750'},
        ]
      },


      chartSettings_elderly:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          age:"年龄",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          man:"男",
          woman:'女',
        }
      },
      chartData_elderly: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['age', 'man','woman'],
        rows: [
          {'age':'60-65','man':'20','woman':'22'},
          {'age':'66-70','man':'14','woman':'17'},
          {'age':'71-75','man':'10','woman':'12'},
          {'age':'76-80','man':'8','woman':'7'},
          {'age':'81-120','man':'7','woman':'4'},
        ]
      },

      chartSettings_goods:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          class:"项目分类",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          total:"销售占比"
        }
      },
      chartData_goods: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['class', 'total'],
        rows: [
          {'class':'家政','total':'203'},
          {'class':'助餐','total':'143'},
          {'class':'护理','total':'93'},
          {'class':'康复','total':'60'},
          {'class':'精神慰藉','total':'35'},
          {'class':'智能设备','total':'22'},
        ]
      },



      elderlyCount:0,
      elderlyCountMan:0,
      elderlyCountWoman:0,

      businessCount:0,
      serveCount:0,
      deviceCount:0,

      alarmRecordCount:0,
      alarmRecordCountWait:0,


    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = "height:"+(val+140-25)+"px";
    },
  },
  created(){
    this.th = "height:"+(this.$store.state.tableHeight+140-25)+"px";

    this.getElderlyCount();

    this.getBusinessCount();

    this.getServeCount();

    this.getDeviceCount();

    this.getAlarmRecordCount();

  },
  methods:{

    getElderlyCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.elderlyCount = response.data.data.elderlyCount;
              this.elderlyCountMan = response.data.data.elderlyCountMan;
              this.elderlyCountWoman = response.data.data.elderlyCountWoman;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getBusinessCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.businessCount = response.data.data.businessCount;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getServeCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Serve/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.serveCount = response.data.data.serveCount;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getDeviceCount(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"UserDevice/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode:getGovernmentCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.deviceCount = response.data.data.deviceCount;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getAlarmRecordCount(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"AlarmRecord/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode:getGovernmentCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.alarmRecordCount = response.data.data.alarmCount;
              this.alarmRecordCountWait = response.data.data.alarmCountWait;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


  }

}


</script>

